import React, {Component, ReactElement} from 'react'
import {
    ContentsMainTitle,
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    IconFont,
    MainContainer,
} from '../../../styledComponents/ContentsArea'
import {
    DISP_TYPE_ALL_MODE,
    DISP_TYPE_ARTICLE_SELECT_MODE,
    LIFE_CONVENIENT_BOOK_CATEGORY,
    TARGET_ATT,
} from '../../../CodeMaster'
import NatLifeNoteRepo from './repository/NatLifeNoteRepo'
import {LifeNoteInfo, NatGetLifeNoteList} from './repository/NatGetLifeNoteList'
import {StyledDiv, StyledI, StyledImg, StyledLi, StyledUl} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {generateMedia} from 'styled-media-query'
import {BreakPoint, Colors} from '../../../styledComponents/Constants'
import {Box} from '@mui/material'
import {PlainAncerLink} from '../../../styledComponents/Links'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {formatForDateInput} from '../../../formatters/formatDate'
import {SortOrder} from '../../../components/shared/SortOrder'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {NatAsyncCallFunction} from '../../common/util/Natutil'
import {Nullable} from '../../../app/TypeHelpers'
import {isIE} from 'react-device-detect'
import {Sticky, StickyContainer} from 'react-sticky'
import {Location} from 'react-router-dom'

interface Props {
    lifeNoteRepo: NatLifeNoteRepo,
    currentDateTimeRepo: NatCurrentDateTimeRepo
    location: Location,
}

interface States {
    imageLifeNoteList: LifeNoteInfo[],
    noImageLifeNoteList: NoImageLifeNoteList[],
    isLoadCompleted: boolean,
}

interface NoImageLifeNoteList {
    categoryLabel: string
    lifeNoteList: LifeNoteInfo[]
}

class NatResidentLifeNoteListPage extends Component<Props & ResidentPagePropsSet, States> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            imageLifeNoteList: [],
            noImageLifeNoteList: [],
            isLoadCompleted: false,
        }
    }

    async componentDidMount(): Promise<void> {
        const searchParams: string[] = []

        await this.props.eventEmitter.showLoading()
        try {
            const searchConditionSortInfo: SortOrder[] = [
                new SortOrder('sortOrder', 'asc'),
                new SortOrder('updateDatetime', 'desc'),
            ]

            const currentDateTime: Nullable<NatGetCurrentDateTime> = await NatAsyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(
                    this.props.currentDateTimeRepo), this.props.navigate)

            if (currentDateTime && currentDateTime.details) {
                searchParams.push(
                    `extractStart=${formatForDateInput(`${currentDateTime.details.currentDateTime}+09:00`)}&extractEnd=${formatForDateInput(`${currentDateTime.details.currentDateTime}+09:00`)}`,
                )
                searchConditionSortInfo.forEach((sortInfo) => {
                    const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
                    searchParams.push(`sortInfo=${value}`)
                })
                // 生活便利帳取得
                const lifeNoteListResult: Nullable<NatGetLifeNoteList> = await NatAsyncCallFunction(
                    this.props.lifeNoteRepo.getLifeNoteList.bind(
                        this.props.lifeNoteRepo, searchParams.join('&')), this.props.navigate)

                if (lifeNoteListResult && lifeNoteListResult.details) {
                    const bannerLifeNoteList: LifeNoteInfo[] = []
                    const linkLifeNoteList: LifeNoteInfo[] = []
                    const noBannerLifeNoteList: LifeNoteInfo[] = []
                    const areaLifeNoteList: LifeNoteInfo[] = []
                    // 生活便利帳をカテゴリで分ける
                    lifeNoteListResult.details.lifeNoteInfo.forEach((lifeNote) => {
                        switch (lifeNote.displayCategory) {
                            case DISP_TYPE_ARTICLE_SELECT_MODE.BANNER.value :
                                bannerLifeNoteList.push(lifeNote)
                                break
                            case DISP_TYPE_ALL_MODE.LINK.value :
                                linkLifeNoteList.push(lifeNote)
                                break
                            case DISP_TYPE_ARTICLE_SELECT_MODE.NO_BANNER.value :
                                noBannerLifeNoteList.push(lifeNote)
                                break
                            case DISP_TYPE_ALL_MODE.AREA_INFO.value :
                                areaLifeNoteList.push(lifeNote)
                                break
                        }
                    })

                    // 画像あり/なしで分ける
                    const imageLifeNoteList: LifeNoteInfo[] = bannerLifeNoteList.concat(linkLifeNoteList)
                    const noImageLifeNoteList: LifeNoteInfo[] = noBannerLifeNoteList.concat(areaLifeNoteList)

                    this.setState({
                        imageLifeNoteList: imageLifeNoteList,
                        noImageLifeNoteList: this.NoImageLifeNoteClassification(noImageLifeNoteList),
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    NoImageLifeNoteClassification(lifeNoteList: LifeNoteInfo[]): NoImageLifeNoteList[] {
        const noImageLifeNoteList: NoImageLifeNoteList[] = []

        const order = [
            LIFE_CONVENIENT_BOOK_CATEGORY.GOVERNMENT.value,
            LIFE_CONVENIENT_BOOK_CATEGORY.DISASTER_PREVENTION.value,
            LIFE_CONVENIENT_BOOK_CATEGORY.LIFE.value,
            LIFE_CONVENIENT_BOOK_CATEGORY.VALUABLE.value,
            LIFE_CONVENIENT_BOOK_CATEGORY.OTHER.value,
        ]

        LIFE_CONVENIENT_BOOK_CATEGORY.values().sort((x, y) => {
            return order.indexOf(x.value) - order.indexOf(y.value)
        }).map((category) => {
            const categoryLifeNote = lifeNoteList.filter((lifeNote) => lifeNote.categoryId === category.value)
            if (categoryLifeNote.length > 0) {
                noImageLifeNoteList.push({categoryLabel: category.label, lifeNoteList: categoryLifeNote})
            }
        })

        return noImageLifeNoteList
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <ContentsMainTitle><TitleIcon/>生活便利帳</ContentsMainTitle>
                <Box pt={'20px'}>
                    {this.state.imageLifeNoteList.length > 0 &&
                        <Box pb={'30px'}>
                            <MainContainer>
                                <LifeNoteBannerList>
                                    {this.state.imageLifeNoteList.map((lifeNote) => (
                                        <LifeNoteBanner key={lifeNote.lifeNoteId}>
                                            <LifeNoteImgWrapper>
                                                {(lifeNote.targetAttr === TARGET_ATT.NEW.value) ?
                                                    (isIE) ?
                                                        <FlexAncerLinkPointer
                                                            onClick={() => window.open(lifeNote.url)}
                                                            target={'_blank'}>
                                                            <LifeNoteImg
                                                                src={`${lifeNote.path}?${new Date().getTime()}`}
                                                                alt={lifeNote.title}/>
                                                        </FlexAncerLinkPointer>
                                                        :
                                                        <FlexAncerLink
                                                            href={(lifeNote.url)}
                                                            target={'_blank'}>
                                                            <LifeNoteImg
                                                                src={`${lifeNote.path}?${new Date().getTime()}`}
                                                                alt={lifeNote.title}/>
                                                        </FlexAncerLink>
                                                    :
                                                    <FlexAncerLink
                                                        href={lifeNote.url}
                                                        target={'_self'}>
                                                        <LifeNoteImg src={`${lifeNote.path}?${new Date().getTime()}`}
                                                                     alt={lifeNote.title}/>
                                                    </FlexAncerLink>
                                                }
                                            </LifeNoteImgWrapper>
                                            <LifeNoteDescripcion>
                                                {lifeNote.description}
                                            </LifeNoteDescripcion>
                                        </LifeNoteBanner>
                                    ))}
                                </LifeNoteBannerList>
                            </MainContainer>
                        </Box>
                    }
                    {this.state.noImageLifeNoteList.map((lifeNoteInfo, index) => {
                        return (
                            <StickyContainer key={`noImageLifeNote_${index}`}>
                                <Sticky>
                                    {({style}) =>
                                        <StickyCategoryWrapper style={style}>
                                            <ContentsSubTitleInner>
                                                {lifeNoteInfo.categoryLabel}
                                            </ContentsSubTitleInner>
                                        </StickyCategoryWrapper>
                                    }
                                </Sticky>
                                <Box pt={'15px'} pb={'30px'}>
                                    <MainContainer>
                                        <Box pb={'15px'}>
                                            {lifeNoteInfo.lifeNoteList.map((lifeNote) => (
                                                <LifeNoteLinkList key={`${lifeNote.lifeNoteId}`}>
                                                    <li>
                                                        {(lifeNote.targetAttr === TARGET_ATT.NEW.value) ?
                                                            (isIE) ?
                                                                <PlainAncerLinkUnderLine
                                                                    onClick={() => window.open(lifeNote.url)}
                                                                    target={'_blank'}>
                                                                    {lifeNote.title}
                                                                </PlainAncerLinkUnderLine> :
                                                                <PlainAncerLink
                                                                    href={lifeNote.url}
                                                                    target={'_blank'}>
                                                                    {lifeNote.title}
                                                                </PlainAncerLink>
                                                            :
                                                            <PlainAncerLink
                                                                href={lifeNote.url}
                                                                target={'_self'}>
                                                                {lifeNote.title}
                                                            </PlainAncerLink>
                                                        }
                                                        <ExplainText>{lifeNote.description}</ExplainText>
                                                    </li>
                                                </LifeNoteLinkList>
                                            ))}
                                        </Box>
                                    </MainContainer>
                                </Box>
                            </StickyContainer>
                        )
                    })}
                </Box>
            </>
        )
    }
}

export default createResidentPage(NatResidentLifeNoteListPage)

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

// タイトルアイコン
const TitleIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;
  color: #ff8b2e;

  &::before {
      content: "\f124";
  }
`


const LifeNoteBannerList: StyledUl = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  align-items: flex-start;
`

const LifeNoteBanner: StyledLi = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  width: 32%;
  text-align: center;
  position: relative;
  word-break: break-all;
  padding-bottom: 30px;

  ${breakPoint.lessThan('sp')`
    width: 100%;
  `}
`

const LifeNoteImgWrapper: StyledDiv = styled.div`
  height: 100%;
  min-height: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const ExplainText: StyledDiv = styled.div`
  white-space: pre-wrap;
`

const LifeNoteDescripcion = styled(ExplainText)`
  width: 100%;
  height: 100%;
`

const FlexAncerLink = styled(PlainAncerLink)`
  min-height: 0;
  flex-shrink: 0;
`

const LifeNoteImg: StyledImg = styled.img`
  width: 100%;
  height: auto;
  flex-shrink: 0;
  vertical-align: bottom;
`

const LifeNoteLinkList: StyledUl = styled.ul`
  padding-bottom: 15px;
`

const PlainAncerLinkUnderLine = styled(PlainAncerLink)`
  text-decoration: underline;
  cursor: pointer;
`

const FlexAncerLinkPointer = styled(FlexAncerLink)`
  cursor: pointer;
`

const StickyCategoryWrapper = styled(ContentsSubTitleWrapper)`
  margin: 0;
  background: ${Colors.Background};
`
